import {
  CERTIFICATION,
  COMPANY,
  FOLLOW_US,
  FOOTER_BUTTON_SETS,
  FOOTER_COL_SETS,
  FOOTER_DESC,
  QUERY,
} from './dataset';
import { ButtonList, List, MainHead, SubHead } from './FooterComponents';
import { FooterStyle } from './styles';

export default function Footer({
  backgroundColor,
}: {
  backgroundColor?: string;
}): JSX.Element {
  return (
    <FooterStyle data-testid="Footer">
      <div
        className={
          backgroundColor ? backgroundColor + ' py-20' : 'bg-font-500 py-20'
        }
      >
        <div className="wg-container">
          <div className="flex gap-4 sm:flex-col">
            <div className=" w-1/4 sm:w-full md:w-2/3">
              <img
                src="https://assets1.cleartax-cdn.com/cleartax/images/1661151661_clear_logo.svg"
                alt="Clear Logo"
                width="153"
                height="28"
              />
              <div className="sm:flex md:gap-4 sm:gap-4">
                <div className="sm:w-1/2">
                  <div className="mt-10">
                    <SubHead text={FOLLOW_US.heading} />
                    <div className="flex gap-2 sm:gap-1">
                      {FOLLOW_US.images.map((follow) => (
                        <a key={follow.imageLink} href={follow.redirectUrl}>
                          <img
                            src={follow.imageLink}
                            alt={follow.altText}
                            width="24"
                            height="24"
                          />
                        </a>
                      ))}
                    </div>
                  </div>

                  <div className="mt-10">
                    <SubHead text={QUERY.heading} />
                    {QUERY.lists.map((list) => (
                      <List key={list.text} text={list.text} link={list.link} />
                    ))}
                  </div>
                </div>

                <div className="mt-10">
                  <MainHead
                    heading={COMPANY.heading}
                    borderBottomRequired={false}
                  />
                  <div className="mt-4">
                    {COMPANY.lists.map((list) => (
                      <List key={list.text} text={list.text} link={list.link} />
                    ))}
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full">
              <div>
                {FOOTER_COL_SETS.map((sec) => (
                  <div key={`footerHead_${sec.heading}`}>
                    <MainHead heading={sec.heading} />
                    <div className="flex flex-wrap mb-10">
                      {sec.child.map((item) => {
                        return (
                          <div
                            key={item.id}
                            className="w-3/12 md:w-1/2 sm:w-1/2"
                          >
                            <SubHead text={item.subHead} />
                            {item.lists.map((list) => (
                              <List
                                key={`${item.id}_${list.text}`}
                                text={list.text}
                                link={list.link}
                              />
                            ))}
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>

          <div>
            {FOOTER_BUTTON_SETS.map((buttonSet) => (
              <div key={buttonSet.heading}>
                <MainHead heading={buttonSet.heading} />

                <div className="flex flex-wrap gap-3 mt-6 mb-10">
                  {buttonSet.lists.map((list) => (
                    <ButtonList
                      key={list.text}
                      text={list.text}
                      link={list.link}
                    />
                  ))}
                </div>
              </div>
            ))}
          </div>

          <div className="mt-12 pt-6 borderTop">
            {FOOTER_DESC.map((desc) => (
              <p key={desc} className="text-s-12 text-justify mb-4 fontLight">
                {desc}
              </p>
            ))}
          </div>

          <div className="mt-20 flex justify-between gap-8 md:flex-col sm:flex-col sm:mt-10">
            <div>
              <p
                className={`text-base font-bold tracking-wide uppercase mb-2 greyMedium`}
              >
                Cleartax is a product by Defmacro Software Pvt. Ltd.
              </p>
              <p className="flex gap-8 text-s-14 fontLight">
                <a
                  href="https://www.clear.in/meta/privacy"
                  className="text-inherit"
                >
                  Privacy Policy
                </a>
                <a
                  href="https://www.clear.in/meta/terms"
                  className="text-inherit"
                >
                  Terms of use
                </a>
              </p>
            </div>
            <div className="flex gap-8 sm:flex-col">
              {CERTIFICATION.map((item) => (
                <div className="flex items-center gap-3" key={item.altText}>
                  <img
                    src={item.image}
                    alt={item.altText}
                    width={item.imageWidth}
                    height={item.imageHeight}
                    loading="lazy"
                  />
                  <div>
                    {item.texts.map((text) => (
                      <p key={text} className="text-s-14 fontLight">
                        {text}
                      </p>
                    ))}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </FooterStyle>
  );
}
